import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e58a1036"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "clearfix mg-b--15"
};
const _hoisted_2 = {
  key: 0,
  class: "mk-module-title--normal float--left mg-b--0"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-title fs--18 mg-r--5"
}, null, -1));
const _hoisted_4 = {
  class: "float--right"
};
const _hoisted_5 = {
  key: 0,
  class: "table-column-option-btn"
};
const _hoisted_6 = {
  class: "pagination__container mg-t--15"
};
import { ref, nextTick } from 'vue';
import Column from './Column.vue';
import Buttons from '@/components/Buttons/index.vue';
import { getTextWidth } from '@/utils';
import { useI18n } from 'vue-i18n';
const __default__ = {
  name: 'CommonTable',
  inheritAttrs: false
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    render: {
      type: Function
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    columnConfig: {
      type: Object,
      default: {}
    },
    paginationConfig: {
      type: Object,
      default: () => ({})
    },
    // 翻页信息
    page: {
      type: Object,
      default: () => ({
        page: 1,
        limit: 10,
        totalNum: 0 // 总条数
      })
    },

    // 是否显示翻页
    showPagination: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: {
        loading: false // 显示loading效果
      }
    },

    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    rowSelectIndex: {
      type: Number,
      default: -1
    },
    dynamicOption: {
      type: Boolean,
      default: false
    },
    // 是否显示过滤筛选列按钮
    showColumnOptions: {
      type: Boolean,
      default: true
    },
    optionColumnList: {
      type: Array,
      default: () => []
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  emits: ['set-options-btn-column-width', 'row-click', 'selection-change', 'current-change', 'size-change', 'sort-change', 'cell-dblclick', 'expand-change'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const commonTableRef = ref(null);
    const handleRowClick = (row, col, event) => {
      emit('row-click', row, col, event);
    };
    const handleSizeChange = val => {
      props.paginationConfig.limit = val;
      props.render && props.render();
      emit('size-change', val);
    };
    const handlePagination = val => {
      props.paginationConfig.page = val;
      props.render && props.render();
      emit('current-change', val);
    };
    const handleSelectionChange = val => {
      emit('selection-change', val);
    };
    const handleSortChange = column => {
      emit('sort-change', column);
    };
    const handleDbclick = (row, column, cell, event) => {
      emit('cell-dblclick', row, column, cell, event);
    };
    const handleExpandChange = (row, expanded) => {
      emit('expand-change', row, expanded);
    };
    const isRowSelect = ({
      row,
      rowIndex
    }) => {
      row.index = rowIndex;
      return row.index === props.rowSelectIndex ? 'is-row-select' : '';
    };
    const filterColumnItemChange = () => {
      nextTick(() => {
        commonTableRef.value && commonTableRef.value.doLayout();
      });
    };
    watch(() => props.tableConfig.data, val => {
      if (!props.dynamicOption) return;
      setTimeout(() => {
        let minOptionsTextWidth = getTextWidth(t('操作'), {
          fontSize: '14px',
          fontWeight: 'bold'
        }) + 30;
        // console.log('minOptionsTextWidth', minOptionsTextWidth);
        let btnList = document.querySelectorAll('.buttons__list');
        let maxWidthArr = [];
        let itemWidth = 0;
        btnList.length > 0 && btnList.forEach((item, index) => {
          // if (index > 0) {
          // console.log('item.children', item.children);
          let childText = '';
          if (item.children.length) {
            for (let i = 0; i < item.children.length; i++) {
              // console.log('child', item.children[i].innerText);
              childText = childText + item.children[i].innerText;
            }
            // console.log('childText', childText);
            let width = getTextWidth(childText, {
              fontSize: '14px'
            }) + 10 * item.children.length;
            itemWidth = width + 6 * item.children.length;
            // console.log('itemWidth', itemWidth);
            maxWidthArr.push(itemWidth);
          }
          // }
        });

        let max = maxWidthArr.length ? Math.max.apply(null, maxWidthArr) + 14 : minOptionsTextWidth;
        // console.log('optionsBtnClientWidth', max,  minOptionsTextWidth);
        emit('set-options-btn-column-width', max > minOptionsTextWidth ? max : minOptionsTextWidth);
        btnList = null;
        // console.log('optionsBtnClientWidth', maxWidthArr, minOptionsTextWidth, max);
        // nextTick(() => {
        //   commonTableRef.value.doLayout()
        // })
      });
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      commonTableRef
    });
    return (_ctx, _cache) => {
      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['basic__table', {
          'mk-card-block': __props.tableConfig.isCardBlock ?? true
        }])
      }, [__props.tableConfig?.isShowHeader ?? true ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.showTitle ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createTextVNode(" " + _toDisplayString(__props.tableConfig.listName ? _ctx.$t(__props.tableConfig.listName) : _ctx.$t('数据列表')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "headerBtnSlot"), _createVNode(Buttons, {
        buttonsList: __props.tableConfig.headerButtonsList
      }, null, 8, ["buttonsList"]), __props.showColumnOptions && __props.optionColumnList.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_TableColumnOptionBtn, {
        "column-list": __props.optionColumnList,
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_table, _mergeProps({
        class: __props.dynamicOption ? 'dynamicOption' : '',
        ref_key: "commonTableRef",
        ref: commonTableRef,
        "row-class-name": isRowSelect,
        onRowClick: handleRowClick,
        border: ""
      }, __props.tableConfig, {
        "header-row-class-name": "color--table",
        onSelectionChange: handleSelectionChange,
        onSortChange: handleSortChange,
        onCellDblclick: handleDbclick,
        onExpandChange: handleExpandChange,
        "tooltip-effect": "light"
      }), {
        default: _withCtx(() => [_createVNode(Column, _normalizeProps(_guardReactiveProps(__props.columnConfig)), null, 16), _renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 16, ["class"])), [[_directive_loading, __props.options.loading]]), _renderSlot(_ctx.$slots, "tableunder"), _withDirectives(_createElementVNode("div", _hoisted_6, [__props.showPagination ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        onSizeChange: handleSizeChange,
        onCurrentChange: handlePagination,
        "current-page": __props.paginationConfig.page || 1,
        "page-sizes": [10, 20, 40, 100],
        "page-size": __props.paginationConfig.limit || 10,
        total: Number(__props.paginationConfig.total) || 0,
        layout: __props.layout
      }, null, 8, ["current-page", "page-size", "total", "layout"])) : _createCommentVNode("", true)], 512), [[_vShow, __props.tableConfig?.showPageBar ?? true]]), _renderSlot(_ctx.$slots, "footer")], 2);
    };
  }
});